import { HorizontalSafeAreaContainer } from '../../../components';
import { ScanAtCheckoutScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <HorizontalSafeAreaContainer>
      <ScanAtCheckoutScreen />
    </HorizontalSafeAreaContainer>
  );
}
